import React from "react";
import "./parallex.css";
import { Link } from "react-router-dom";

import img1 from "../../assets/images/industries/retail-ecommerce.png";
import img2 from "../../assets/images/industries/education-e-learning.png";
import img3 from "../../assets/images/industries/healthcare-fitness.png";
import img4 from "../../assets/images/industries/logistics-distribution.png";
import img5 from "../../assets/images/industries/social-networking.png";
import img6 from "../../assets/images/industries/real-estate.png";
import img7 from "../../assets/images/industries/travel-hospitality.png";
import img8 from "../../assets/images/industries/food-restaurant.png";
import img9 from "../../assets/images/industries/on-demand-solutions.png";
import img10 from "../../assets/images/industries/gaming.png";
import img11 from "../../assets/images/industries/healthcare.png";
import img12 from "../../assets/images/industries/product-manufacturer-img.png";
import img13 from "../../assets/images/industries/doctor.png";
import img14 from "../../assets/images/industries/bfsi-solution.png";

const industries = [
    { img: img14, name: "BFSI Solutions", route: '/industries/bfsi-solution' },
    { img: img13, name: "Doctors", route: '/industries/doctors' },
    { img: img2, name: "Education & E-learning", route: '/industries/education' },
    { img: img8, name: "Food & Restaurant", route: '#' },
    { img: img10, name: "Gaming", route: '/industries/sports-gaming' },
    { img: img11, name: "Healthcare", route: '/industries/healthcare' },
    { img: img3, name: "Healthcare & Fitness", route: '/industries/healthcare' },
    { img: img4, name: "Logistics & Distribution", route: '/industries/logistics' },
    { img: img9, name: "On-Demand Solutions", route: '#' },
    { img: img12, name: "Product Manufacturer", route: '/industries/product-manufacturer' },
    { img: img6, name: "Real Estate", route: '/industries/real-estate' },
    { img: img1, name: "Retail & E-commerce", route: '/industries/e-commerce' },
    { img: img5, name: "Social Networking", route: '#' },
    { img: img7, name: "Travel & Hospitality", route: '#' },
];

const ParallaxSection = ({ title, backgroundImage1 }) => {
  return (
    <div
      className="parallax-section"
      style={{ backgroundImage: `url(${backgroundImage1})` }}
    >
      <div className="parallax-content">
        <div className="white-box">
          <h1 className="section-title1">{title}</h1>
          <p>Here, we make almost every genre of applications. You name it and we build it.</p>
          <div className="industries-grid">
            {industries.map((item, index) => (
              <div className="industry-item" key={index}>
                <Link to={item.route}><img src={item.img} alt={item.name} /></Link>
                <Link to={item.route}><p>{item.name}</p></Link>

              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParallaxSection;
